<div class="box">
  <app-wizard
    [items]="steps"
    [prevButtonText]="''"
    [nextButtonText]="''"
    [prevButtonEnabled]="false"
    [nextButtonEnabled]="false"
    [prevButtonHasChevron]="false"
    [nextButtonHasChevron]="false"
    [showIcons]="false"
    [showFooter]="false"
    (stepSelection)="setActive($event)"
  >
    <!-- 1) Admin -->
    <app-wizard-step
      [stepNumber]="1"
      [stepId]="'wizard-admin'"
      [isActive]="isActive(0)"
    >
      <app-project-admin-idea-step
        [form]="form.controls.admin"
        [project]="project()"
        [loading]="loading()"
      />
    </app-wizard-step>

    <!-- 2) Alapadatok -->
    <app-wizard-step
      [stepNumber]="2"
      [stepId]="'wizard-basics'"
      [isActive]="isActive(1)"
    >
      <app-project-idea-fields
        [form]="form.controls.basic"
        [project]="project()"
        [loading]="loading()"
      />
    </app-wizard-step>
  </app-wizard>

  <div class="d-flex justify-content-end gap-2">
    <app-button
      [btnClass]="
        'btn btn-outline-secondary btn-sm d-flex align-items-center gap-2'
      "
      [label]="'general.cancel' | translate"
      [ariaLabel]="'general.cancel' | translate"
      (clicked)="cancel()"
    />
    <app-button
      [btnClass]="'btn btn-primary btn-sm d-flex align-items-center gap-2'"
      [label]="'general.save' | translate"
      [ariaLabel]="'general.save' | translate"
      [iconClass]="'fas fa-save'"
      [disabled]="form.invalid"
      (clicked)="save()"
    />
  </div>
</div>
